import { z } from "zod";

const INVALID_EMAIL = "Enter a valid email";

const emailSchema = z.string().trim().email(INVALID_EMAIL);

export const invoiceInformationFormSchema = z.object({
  address: z.string(),
  billToEmail: z.string().trim().min(1, "Enter an email").pipe(emailSchema),
  companyName: z.string(),
  fullName: z.string(),
  notes: z.string(),
  secondaryEmail: z
    .string()
    .trim()
    .refine(
      (email) => email === "" || emailSchema.safeParse(email).success,
      INVALID_EMAIL,
    ),
});

export type InvoiceInformationFormValues = z.infer<
  typeof invoiceInformationFormSchema
>;
